import React from "react";
import Pill from "../../components/Pill/Pill";
import { BookingFormType } from "../../components/BookingForm/BookingForm";
import { useTranslation } from "react-i18next";

interface BookingTypeCardProps {
  booking: BookingFormType;
  onEdit: () => void;
}

const BookingTypeCard: React.FC<BookingTypeCardProps> = ({ booking, onEdit }) => {

  const { t } = useTranslation();

  return (
    <div className="flex items-center space-x-4"
      onClick={onEdit}
    >
        <div className="text-lg font-bold">{booking.name}</div>
        {booking.requiresFee || booking.requiresRefundableFee ? (
          <Pill text={t("bookings.listing.paid")} color="blue" />
        ) : (
          <Pill text={t("bookings.listing.free")} color="green" />
        )}
    </div>
  );
};

export default BookingTypeCard;